module.exports = __webpack_public_path__ + "static/img/opeyemi.4208724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/opeyemi.png
// module id = qBov
// module chunks = 0